import { Box, Button, Container, Grid, Link, Paper, Stack, Typography } from '@mui/material';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import "./styles.css"
import { isDesktop } from 'react-device-detect';
import WpMainTitle from '../../svgs/WpMainTitle';
import FeaturedPost from './FeaturedPost';
import styles from './styles.module.css'
import { animated, useScroll, useSpring, useTransition } from '@react-spring/web';
import { ContainerDiv, Message, Content, Life } from './styles'
import { getImageSize, useImageSize } from 'react-image-size';
import logo from "../../W_Logo Full.png"; // путь до PNG

let id = 0

interface MessageHubProps {
  config?: {
    tension: number
    friction: number
    precision: number
  }
  timeout?: number
  children: (add: AddFunction) => void
}

type AddFunction = (msg: string) => void

interface Item {
  key: number
  msg: string
}

async function fetchImageSize(path: string) {
  try {
    debugger
    const dimensions = await getImageSize(path);
    return dimensions
  } catch (error) {
    console.error(error);
  }
}

function MessageHub({
  config = { tension: 125, friction: 20, precision: 0.1 },
  timeout = 2500,
  children,
}: MessageHubProps) {
  const refMap = useMemo(() => new WeakMap(), [])
  const cancelMap = useMemo(() => new WeakMap(), [])
  const [items, setItems] = useState<Item[]>([])

  const transitions = useTransition(items, {
    from: { opacity: 0, height: 0, life: '100%' },
    keys: item => item.key,
    enter: item => async (next, cancel) => {
      debugger
      var a = await fetchImageSize((item as any).msg);
      cancelMap.set(item, cancel)
      await next({ opacity: 1, height: a?.height  /* refMap.get(item).offsetHeight  */ })
      await next({ life: '  0%' })
    },
    leave: [{ opacity: 0 }, { height: 0 }],
    onRest: (result, ctrl, item) => {

      debugger
      setItems(state =>
        state.filter(i => {
          return i.key !== item.key
        })
      )
    },
    config: (item, index, phase) => key => phase === 'enter' && key === 'life' ? { duration: timeout } : config,
  })

  useEffect(() => {

    children((msg: any) => {
      setItems(state => [...state, { key: id++, msg }])
    })
  }, [])

  return (
    <ContainerDiv>
      {transitions(({ life, ...style }, item) => (
        <Message style={style}>
          <Content ref={(ref: HTMLDivElement) => ref && refMap.set(item, ref)} style={{ height: '100%' }}>
            {/* <Life style={{ right: life }} /> */}
            <img src={item.msg} style={{ maxHeight: '100%' }} width='100%' />

            {/*   <p>{item.msg}</p> */}
            {/*  <Button
              onClick={(e: MouseEvent) => {
                e.stopPropagation()
                if (cancelMap.has(item) && life.get() !== '0%') cancelMap.get(item)()
              }}>
              <X size={18} />
            </Button> */}
          </Content>
        </Message>
      ))}
    </ContainerDiv>
  )
}
export default function Main() {
  const [buttonSize, setButtonSize] = useState({ fontSize: "1.5rem", padding: "15px 50px" });

  const MINUTE_MS = 2000;


  var res = [
    "1.png",
    "2.png",
    "3.png"

  ]
  const [mytime, setMytime] = useState(0);

  useEffect(() => {

    var c = 0
    const interval = setInterval(() => {

      ref.current?.(res[mytime])

      setMytime((prevTime) => prevTime == 2 ? 0 : prevTime + 1);


    }, MINUTE_MS);

    return () => clearInterval(interval); // This represents the unmount function, in which you need to clear your interval to prevent memory leaks.
  }, [mytime])

    const [fontSize, setFontSize] = useState("1.5rem");



    useEffect(() => {
    function updateFont() {
      if (imgRef.current) {
        // Шрифт = 15% от ширины картинки
        const newFontSize = (imgRef.current as any).offsetWidth * 0.15;
        setFontSize(`${newFontSize}px`);
      }
    }

    updateFont();
    window.addEventListener("resize", updateFont);
    return () => window.removeEventListener("resize", updateFont);
  }, []);

  var onHelpClick = () => {
    window.open("https://t.me/whypnbot", "_blank")
  }
  const sidebar = {
    title: 'About',
    description:
      'Etiam porta sem malesuada magna mollis euismod. Cras mattis consectetur purus sit amet fermentum. Aenean lacinia bibendum nulla sed consectetur.',
    archives: [
      { title: 'March 2020', url: '#' },
      { title: 'February 2020', url: '#' },
      { title: 'January 2020', url: '#' },
      { title: 'November 1999', url: '#' },
      { title: 'October 1999', url: '#' },
      { title: 'September 1999', url: '#' },
      { title: 'August 1999', url: '#' },
      { title: 'July 1999', url: '#' },
      { title: 'June 1999', url: '#' },
      { title: 'May 1999', url: '#' },
      { title: 'April 1999', url: '#' },
    ],
    social: [
      { name: 'GitHub' },
      { name: 'X' },
      { name: 'Facebook' },
    ],
  };

  var social = [
    { name: 'GitHub' },
    { name: 'X' },
    { name: 'Facebook' },
  ]
  var archives = [
    { title: 'March 2020', url: '#' },
    { title: 'February 2020', url: '#' },
    { title: 'January 2020', url: '#' },
    { title: 'November 1999', url: '#' },
    { title: 'October 1999', url: '#' },
    { title: 'September 1999', url: '#' },
    { title: 'August 1999', url: '#' },
    { title: 'July 1999', url: '#' },
    { title: 'June 1999', url: '#' },
    { title: 'May 1999', url: '#' },
    { title: 'April 1999', url: '#' },
  ]
   const imgRef = useRef(null);

  const [state, toggle] = useState(true)
  const { x } = useSpring({
    from: { x: 0 },
    x: state ? 1 : 0,
    config: { duration: 2000 },
  })

  const ref = useRef<null | AddFunction>(null)
  const [scrollVal, setScrollVal] = React.useState(0);


  const { scrollYProgress } = useScroll({
    onChange: ({ value: { scrollYProgress } }) => {
      setScrollVal(scrollYProgress + 1);
    }
  });

  const isEnglish = navigator.language.startsWith("en"); // true, если язык браузера английский

  return (
  <Container
      maxWidth="lg"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "90vh",
      }}
    >
      <div className="image" style={{ display: "flex", justifyContent: "center" }}>
        <div
          className="main__sub"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          <img
            src={logo}
            alt="Logo"
            style={{
              width: "90%",
              maxWidth: "800px",
              minWidth: "250px",
              height: "auto",
            }}
            ref={imgRef}
          />
          <Typography
            sx={{ mt: 1 }}
            fontWeight={300}
            color="white"
            className="main__subname"
            gutterBottom
            style={{
              textAlign: "center",
              fontSize: imgRef.current
                ? `${Math.min(
                    Math.max((imgRef.current as any).offsetWidth * 0.12, 18),
                    80
                  )}px`
                : "1.5rem",
            }}
          >
            {isEnglish ? "Your Internet Shield" : "твой Интернет-щит"}
          </Typography>

          <Box
            sx={{
              display: "inline-block",
              border: "2px solid white",
              borderRadius: "45px",
              p: 1,
              mt: 2,
            }}
          >
            <Button
              onClick={onHelpClick}
              className="main__button"
              style={{
                fontSize: "clamp(1rem, 4vw, 1.5rem)",
                padding: "clamp(8px, 1.5vw, 15px) clamp(20px, 4vw, 50px)",
                minWidth: "120px",
                textAlign: "center",
              }}
            >
              {isEnglish ? "Protect Me" : "Защитите меня"}
            </Button>
          </Box>
        </div>
      </div>
    </Container>


  );
}


